import { default as styled } from 'styled-components';

import { fontTextSmMedium } from '@/styles/helpers';

export const ExceptionContainer = styled.div`
  background-color: ${(p) => p.theme.colors.white};
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const IconWrapper = styled.div`
  margin-bottom: 16px;

  display: flex;
  justify-content: center;
  & > svg {
    width: 68px;
    height: 64px;
    display: block; /* NOTE: to avoid extra space below the svg */
  }
`;

export const Text = styled.p`
  ${fontTextSmMedium};
  text-align: center;
  max-width: 80%;
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
`;
